import { AudienceFilter, defineTopic } from 'magpie-lib/models';
import { targetElementRectsMessages } from './targetElementRects.messages';
export const TARGET_ELEMENT_RECTS_TOPIC = '@nav-onboarding-tour/TARGET_ELEMENT_RECTS_TOPIC';
export const audienceFilter = AudienceFilter.builder().excludeSelf();
export const targetElementRectsTopic = defineTopic({
  name: TARGET_ELEMENT_RECTS_TOPIC,
  messages: [targetElementRectsMessages.requestTargetElementRects, targetElementRectsMessages.sendTargetElementRects],
  enableRuntimeValidation: false,
  audience: audienceFilter.build()
});